import api from '../../api/api'

// initial state
const state = {
	resetPassword: {},
  errors: {},
  status: {
    resetPassword: null,
    confirmPassword: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  resetPassword({commit, state}, params) {
    commit('setErrors', {})
    commit('setStatus', { resetPassword: api.status.PENDING })
    return api.resetPassword(params).then((response) => {
      commit('setResetPassword', response.data)
      commit('setStatus', { resetPassword: api.status.SUCCESS })
    }).catch((error) => {
      commit('setErrors', error.response.data.errors)
      commit('setStatus', { resetPassword: api.status.FAILURE })
    })
  },
  confirmPassword({commit, state}, params) {
    commit('setErrors', {})
    commit('setStatus', { confirmPassword: api.status.PENDING })
    return api.confirmPassword(params).then((response) => {
      commit('setConfirmPassword', response.data)
      commit('setStatus', { confirmPassword: api.status.SUCCESS })
    }).catch((error) => {
      commit('setErrors', error.response.data.errors)
      commit('setStatus', { confirmPassword: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setErrors (state, errors) {
    state.errors = errors
  },
  setResetPassword (state, resetPassword) {
    state.resetPassord = resetPassword
  },
  setConfirmPassword (state, confirmPassword) {
    state.confirmPassord = confirmPassword
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
